(function () {
  if (window.__hopwPillFiltersBound) return;
  window.__hopwPillFiltersBound = true;

  var ROOT_SELECTOR = "[data-hopw-pill-filters]";
  var PILL_SELECTOR = "[data-hopw-pill-filter]";
  var PRODUCT_SELECTOR =
    "[data-hopw-tag-filter-grid] .m-product-item[data-product-tags], #CollectionProductGrid .m-product-item[data-product-tags]";
  var FILTER_PARAM = "hopw_type";

  function normalizeTag(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getProductTags(item) {
    var raw = item.getAttribute("data-product-tags") || "";
    return raw
      .split("|")
      .map(normalizeTag)
      .filter(Boolean);
  }

  function getVisibleCountEl(root) {
    var header = root.closest(".hopw-cl-header");
    if (header) {
      var el = header.querySelector("[data-hopw-visible-count]");
      if (el) return el;
    }
    return document.querySelector("[data-hopw-visible-count]");
  }

  function getFilterFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return normalizeTag(params.get(FILTER_PARAM) || params.get("filter"));
    } catch (e) {
      return "";
    }
  }

  function syncFilterToUrl(filterTag, replace) {
    try {
      var url = new URL(window.location.href);
      var showAll = !filterTag || filterTag === "all";

      // Drop legacy param if present
      url.searchParams.delete("filter");

      if (showAll) {
        url.searchParams.delete(FILTER_PARAM);
      } else {
        url.searchParams.set(FILTER_PARAM, filterTag);
      }

      var next = url.pathname + url.search + url.hash;
      var current = window.location.pathname + window.location.search + window.location.hash;
      if (next === current) return;

      var state = { hopwType: filterTag || "all" };
      if (replace) {
        window.history.replaceState(state, "", next);
      } else {
        window.history.pushState(state, "", next);
      }
    } catch (e) {
      // Preview tools / older browsers may block history updates
    }
  }

  function findPillByTag(root, filterTag) {
    var pills = root.querySelectorAll(PILL_SELECTOR);
    var showAll = !filterTag || filterTag === "all";
    var i;

    if (showAll) {
      for (i = 0; i < pills.length; i++) {
        if (normalizeTag(pills[i].getAttribute("data-hopw-tag")) === "all") return pills[i];
      }
      return pills[0] || null;
    }

    for (i = 0; i < pills.length; i++) {
      if (normalizeTag(pills[i].getAttribute("data-hopw-tag")) === filterTag) return pills[i];
    }

    for (i = 0; i < pills.length; i++) {
      if (normalizeTag(pills[i].getAttribute("data-hopw-tag")) === "all") return pills[i];
    }
    return pills[0] || null;
  }

  function applyFilter(root, activePill, options) {
    if (!root || !activePill) return;

    var opts = options || {};
    var filterTag = normalizeTag(activePill.getAttribute("data-hopw-tag"));
    var showAll = !filterTag || filterTag === "all";
    var pills = root.querySelectorAll(PILL_SELECTOR);
    var items = document.querySelectorAll(PRODUCT_SELECTOR);
    var visibleCountEl = getVisibleCountEl(root);
    var visibleCount = 0;
    var i;

    for (i = 0; i < pills.length; i++) {
      pills[i].classList.toggle("is-active", pills[i] === activePill);
    }

    for (i = 0; i < items.length; i++) {
      var item = items[i];
      var tags = getProductTags(item);
      var isVisible = showAll || tags.indexOf(filterTag) !== -1;

      item.classList.toggle("is-hopw-filter-hidden", !isVisible);
      if (isVisible) {
        item.removeAttribute("hidden");
        visibleCount += 1;
      } else {
        item.setAttribute("hidden", "");
      }
    }

    if (visibleCountEl) {
      visibleCountEl.textContent = String(visibleCount);
    }

    var grid = document.querySelector(
      "[data-hopw-tag-filter-grid], #CollectionProductGrid [data-product-container]"
    );
    var empty = document.querySelector("[data-hopw-filter-empty]");

    if (items.length > 0 && visibleCount === 0) {
      if (!empty && grid) {
        empty = document.createElement("p");
        empty.className = "hopw-cl-filter-empty";
        empty.setAttribute("data-hopw-filter-empty", "");
        empty.textContent = "No products match this filter.";
        grid.insertAdjacentElement("afterend", empty);
      }
      if (empty) empty.hidden = false;
    } else if (empty) {
      empty.hidden = true;
    }

    if (opts.updateUrl !== false) {
      syncFilterToUrl(showAll ? "all" : filterTag, opts.replaceUrl === true);
    }
  }

  function applyFromUrl(updateUrl) {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var filterTag = getFilterFromUrl();
    for (var i = 0; i < roots.length; i++) {
      var pill = findPillByTag(roots[i], filterTag);
      applyFilter(roots[i], pill, {
        updateUrl: updateUrl === true,
        replaceUrl: true,
      });
    }
  }

  function onPillClick(event) {
    var pill = event.target.closest(PILL_SELECTOR);
    if (!pill) return;

    var root = pill.closest(ROOT_SELECTOR);
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();
    applyFilter(root, pill, { updateUrl: true, replaceUrl: false });
  }

  function boot() {
    applyFromUrl(true);
  }

  document.addEventListener("click", onPillClick);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.addEventListener("popstate", function () {
    applyFromUrl(false);
  });

  document.addEventListener("shopify:section:load", function () {
    applyFromUrl(true);
  });

  document.addEventListener("shopify:section:reorder", function () {
    applyFromUrl(true);
  });
})();
